import {
    Component,
    ElementRef,
    OnInit,
    inject,
    viewChild,
} from '@angular/core';
import { MediaService } from '@exl-ng/mulo-core';

import SwiperCore, { A11y, Autoplay, EffectFade, Pagination } from 'swiper';
import { HomepageScope } from '../../shared/interfaces/research-portal/portal-configuration/homepage-configuration.interface';
import { PortalService } from '../portal.service';
import { PortalHomepageSections } from '../../shared/configurations/portal-homepage.constant';
import { UrlUtils } from '../../shared/utils/url.utils';
import { Discovery } from '../../shared/configurations/discovery.constant';
import { ConfigurationHandlerService } from '../../core/configuration-handler.service';
import { State } from '../../shared/configurations/state.constant';
import { SwiperComponent, SwiperModule } from 'swiper/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatMiniFabButton } from '@angular/material/button';

import { AriaSwiperDirective } from '../../shared/directives/a11y/aria-swiper.directive';
import { RouterLink } from '@angular/router';

SwiperCore.use([Pagination, A11y, Autoplay, EffectFade]);

@Component({
    selector: 'esp-portal-intro',
    templateUrl: './portal-intro.component.html',
    styleUrls: ['./portal-intro.component.scss'],
    imports: [
        RouterLink,
        AriaSwiperDirective,
        SwiperModule,
        MatMiniFabButton,
        MatIcon,
        TranslateModule,
    ],
})
export class PortalIntroComponent implements OnInit {
    media = inject(MediaService);
    private portalService = inject(PortalService);
    private configurationHandlerService = inject(ConfigurationHandlerService);

    readonly elementView = viewChild<ElementRef>('content');
    readonly swiperElem = viewChild<SwiperComponent>('swiperElem');
    homepageScopes: HomepageScope[] = [];
    homepageImages = [];
    entities = [];
    isImagesSectionActive = false;

    institutionCode = UrlUtils.getParam('institution');

    get swiperRunning() {
        return this.swiperElem()?.swiperRef?.autoplay.running;
    }
    ngOnInit() {
        this.homepageScopes = this.portalService.getHomepageSectionByCode(
            PortalHomepageSections.SCOPES,
        ).homepageScopes as HomepageScope[];
        this.homepageScopes = this.homepageScopes.filter(
            (scope) => scope.active,
        );
        this.entities = this.configurationHandlerService.activeEntities();

        this.isImagesSectionActive =
            this.portalService.getHomepageSectionByCode(
                PortalHomepageSections.PICTURES,
            ).active;
        if (this.isImagesSectionActive) {
            this.portalService.getHomepageImages().subscribe((data) => {
                this.homepageImages = data as string[];
            });
        }
    }

    getRouterLink() {
        return [State.OUTPUTS_SEARCH];
    }

    getQueryParams(scope: HomepageScope) {
        const queryParams = {
            query: Discovery.SIMPLE_SEARCH__ALL_QUERY,
            page: 1,
            sort: 'date_d',
            enable_asterisk_search: true,
            institution: this.institutionCode,
        };
        if (scope.code === 'research.portal.homepage.etd') {
            queryParams['scope'] = 'ResearchETD';
        } else if (scope.code === 'research.portal.homepage.openAccess') {
            queryParams['scope'] = 'ResearchOA';
        } else if (scope.code === 'research.portal.homepage.nonETD') {
            queryParams['scope'] = 'ResearchNonETD';
        }
        return queryParams;
    }

    getHrefTarget(open) {
        if (open === 'new') {
            return '_blank';
        }
        return '_self';
    }

    getEntityParams(entity) {
        const qParams = {
            ...(entity.qParams || {}),
            institution: this.institutionCode,
        };

        return qParams;
    }

    swiperStop = () => this.swiperElem()?.swiperRef?.autoplay.stop();
    swiperStart = () => this.swiperElem()?.swiperRef?.autoplay.start();
}
